/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView.tsx";
import { OpacityFillingText } from "@/src/animations/OpacityFillingText/OpacityFillingText.tsx";
import { StyleguideInnerProps } from "@/src/styleguide/components/Styleguide/Styleguide.tsx";

const AnimationStyleguide: StyleguideInnerProps["sections"] = [
  {
    id: "text-animations",
    title: "Text animations",
    children: (
      <>
        <StyleguideView title={"Scroll letter opacity"}>
          <OpacityFillingText
            text={
              "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet."
            }
          />
        </StyleguideView>
      </>
    ),
  },
];

export default AnimationStyleguide;
